import { render } from "./ModalPaymentMethod.vue?vue&type=template&id=6f5872ea"
import script from "./ModalPaymentMethod.vue?vue&type=script&lang=js"
export * from "./ModalPaymentMethod.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__